var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"SectionTitle"},[_vm._v("Camp upgrades")]),_vm._v(" "),_c('ul',_vm._l((_vm.upgrades),function(upgrade){return _c('li',{key:upgrade.id},[(upgrade.id === 'fire')?_c('fire',{attrs:{"item":upgrade}}):_vm._e(),_vm._v(" "),(upgrade.id === 'water-collector')?_c('water-collector',{attrs:{"item":upgrade}}):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f97752","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampUpgrades.vue
// module id = OPKB
// module chunks = 1